// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__jdoKe","info":"PatientInfo_info__BUV0U"};